import React from 'react';
import { Header } from '../components/Header';
import { Navigation } from '../components/Navigation';
import { EventCard } from '../components/EventCard';
import { useNavigate } from 'react-router-dom';
export const Home = () => {
  const navigate = useNavigate();
  // Mock data for events
  const events = [{
    id: '1',
    title: 'Summer Club Night',
    date: 'Sat, 15 Jul 2023 • 22:00',
    location: 'Club XYZ, Berlin',
    imageUrl: 'https://images.unsplash.com/photo-1514525253161-7a46d19cd819?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
    availableTables: 5
  }, {
    id: '2',
    title: 'Rooftop Party',
    date: 'Fri, 21 Jul 2023 • 20:00',
    location: 'Skybar, Munich',
    imageUrl: 'https://images.unsplash.com/photo-1429962714451-bb934ecdc4ec?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
    availableTables: 3
  }, {
    id: '3',
    title: 'Techno Festival',
    date: 'Sat, 29 Jul 2023 • 18:00',
    location: 'Warehouse District, Hamburg',
    imageUrl: 'https://images.unsplash.com/photo-1470225620780-dba8ba36b745?ixlib=rb-4.0.3&auto=format&fit=crop&w=500&q=80',
    availableTables: 8
  }];
  return <div className="bg-white min-h-screen pb-16" data-id="element-313">
      <Header title="Partix" showSearch data-id="element-314" />
      <div className="p-4" data-id="element-315">
        <div className="mb-4" data-id="element-316">
          <h2 className="text-xl font-bold text-gray-800 mb-2" data-id="element-317">
            Upcoming Events
          </h2>
          <div className="border-b border-dashed border-gray-300 mb-4" data-id="element-318"></div>
          {events.map(event => <EventCard key={event.id} {...event} onClick={() => navigate(`/event/${event.id}`)} data-id="element-319" />)}
        </div>
      </div>
      <Navigation data-id="element-320" />
    </div>;
};